import gql from "graphql-tag";

export const DELETE_INVOICE = gql`
  mutation deleteInvoice($id: ID!) {
    deleteInvoice(id: $id)
  }
`;
